export const SALUTATIONS = ['Frau', 'Herr', 'Divers'] as const

export const TOPICS = [
    'Steuerberatung',
    'Wirtschaftsprüfung',
    'Lohn- und Finanzbuchhaltung',
    'Existenzgründungsberatung',
    'Sonstiges Anliegen'
] as const

export const FIELD_LIMITS = {
    name: 80,
    company: 120,
    phone: 40,
    email: 160,
    message: 5000
}

export type ContactFormValues = {
    salutation: string
    firstName: string
    lastName: string
    company: string
    phone: string
    email: string
    topic: string
    message: string
    consent: boolean
}

export type ContactFormErrors = Partial<Record<keyof ContactFormValues, string>>

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

// Shared by the form (instant feedback) and the API route (the real check)
export const validateContact = (values: ContactFormValues): ContactFormErrors => {
    const errors: ContactFormErrors = {}

    if (!values.firstName.trim()) errors.firstName = 'Bitte geben Sie Ihren Vornamen an.'
    else if (values.firstName.length > FIELD_LIMITS.name) errors.firstName = 'Der Vorname ist zu lang.'

    if (!values.lastName.trim()) errors.lastName = 'Bitte geben Sie Ihren Nachnamen an.'
    else if (values.lastName.length > FIELD_LIMITS.name) errors.lastName = 'Der Nachname ist zu lang.'

    if (values.company.length > FIELD_LIMITS.company) errors.company = 'Der Firmenname ist zu lang.'

    if (values.phone && !/^[0-9+()\/\-\s]{5,}$/.test(values.phone.trim())) errors.phone = 'Bitte geben Sie eine gültige Telefonnummer an.'
    else if (values.phone.length > FIELD_LIMITS.phone) errors.phone = 'Die Telefonnummer ist zu lang.'

    if (!values.email.trim()) errors.email = 'Bitte geben Sie Ihre E-Mail-Adresse an.'
    else if (!EMAIL_PATTERN.test(values.email.trim()) || values.email.length > FIELD_LIMITS.email) errors.email = 'Bitte geben Sie eine gültige E-Mail-Adresse an.'

    if (values.salutation && !(SALUTATIONS as readonly string[]).includes(values.salutation)) errors.salutation = 'Bitte wählen Sie eine Anrede aus der Liste.'

    if (values.topic && !(TOPICS as readonly string[]).includes(values.topic)) errors.topic = 'Bitte wählen Sie ein Anliegen aus der Liste.'

    if (values.message.trim().length < 10) errors.message = 'Bitte beschreiben Sie Ihr Anliegen in ein paar Worten.'
    else if (values.message.length > FIELD_LIMITS.message) errors.message = `Bitte fassen Sie sich etwas kürzer (höchstens ${FIELD_LIMITS.message} Zeichen).`

    if (!values.consent) errors.consent = 'Bitte stimmen Sie der Verarbeitung Ihrer Angaben zu.'

    return errors
}
